import React, { useEffect } from 'react';
import BackButtonMenu from '../../../../components/BackButtonMenu';
import { Link } from 'react-router-dom';

class Kereszt extends React.Component {
    render() {
        return (
            <img src={process.env.PUBLIC_URL + '/assets/kereszt.png'} alt="kereszt" className='kereszt-icon-projekttortenet' />
        );
    }
}

function AHajokrol() {
      // Preload the kereszt image to prevent flickering
    useEffect(() => {
        const img = new Image();
        img.src = process.env.PUBLIC_URL + '/assets/kereszt.png';
    }, []);
  return (
    <div className='submenu-container'>
      <div className='submenu-text-container'>
          <Kereszt />
          <Link to={"/dunai-hajok"} className='submenu-list-item'>
            A XVI. század elejének Dunai hajói
          </Link>
      </div>
      <div className='submenu-text-container'>
          <Kereszt />
          <Link className='submenu-list-item'>
            Saját hajóink és hajóépítő munkánk
          </Link>
      </div>
      <BackButtonMenu to="/projekt" />
  </div>
  );
}

export default AHajokrol;
